import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

/**
 * SortableCategoryGroup - Wrapper for sortable category groups
 * Used with @dnd-kit for drag-and-drop category reordering
 */
function SortableCategoryGroup({ categoryGroup, children, dragHandleProps }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: categoryGroup.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} className="category-group">
      {children(dragHandleProps ? { ...attributes, ...listeners } : null)}
    </div>
  );
}

export default SortableCategoryGroup;
